import { render, staticRenderFns } from "./ReservationPlateSelection.vue?vue&type=template&id=31a78a95"
import script from "./ReservationPlateSelection.vue?vue&type=script&lang=js"
export * from "./ReservationPlateSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports